import { useCallback, useEffect, useState } from "react"
import Header from "../../components/custom/header"
import Icon from "../../components/custom/icon"
import { useGlobal } from "../../context/global"
import "./index.css"
import { reversePayload, exportHeaders } from "../../data/volunteer"
import { utils, writeFile } from "xlsx-js-style"

const BoxMenu = props => {
    const { config } = props
    return (
        <div className="boxmenu-main" onClick={config.onClick}>
            <div>
                <Icon name={config.icon} size={[20, 3]} color="#555" />
            </div>
            <div className="boxmenu-title">{config.title}</div>
        </div>
    )
}

const Admin = () => {

    const { api, maintenance, toggleMaintenance, auth } = useGlobal()
    const isAppAdmin = auth && auth.users && auth.users.some(u => u.roleID === 'app-admin')

    var [masterData, setMasterData] = useState([])

    const handleToggleMaintenance = () => {
        const nextState = !maintenance.active
        const actionText = nextState ? "activate" : "deactivate"
        if (window.confirm(`Are you sure you want to ${actionText} Maintenance Mode?\n\n${nextState ? "The website will be hidden from all users except App Admin." : "The website will be accessible to everyone again."}`)) {
            toggleMaintenance(nextState)
                .then(() => {})
                .catch(err => alert(err.message || 'Failed to update maintenance mode'))
        }
    }

    const menu = [
        {
            title: "Export Master Data (XL)",
            icon: "download",
            onClick: useCallback(() => {
                var workbook = utils.book_new()
                var header = [exportHeaders.map(h => h.title)]

                var sheetData = header.concat(masterData.map(data => {
                    return exportHeaders.map(exHeader => data[exHeader.key] || '')
                }))

                var worksheet = utils.aoa_to_sheet(sheetData)


                header[0].forEach((_, colIndex) => {
                    const cellAddress = utils.encode_cell({ r: 0, c: colIndex })
                    if (worksheet[cellAddress]) {
                        worksheet[cellAddress].s = {
                            font: {
                                bold: true
                            }
                        }
                    }
                })

                worksheet["!cols"] = sheetData.maxColWidth().map(w => { return { wch: w } })

                utils.book_append_sheet(workbook, worksheet, "Master")
                writeFile(workbook, `Sevabase Master Data.xlsx`)

            }, [masterData])
        },
        ...(isAppAdmin ? [
            {
                title: maintenance.active ? "Maintenance Mode: ACTIVE (Click to Deactivate)" : "Maintenance Mode: INACTIVE (Click to Activate)",
                icon: "engineering",
                onClick: handleToggleMaintenance
            }
        ] : [])
    ]

    useEffect(() => {
        api.call('/get-volunteers').then(res => {
            setMasterData(res.data[3].map(reversePayload))
        }).catch(err => alert(err))
    }, [])

    return (
        <div className="admin-main">
            <Header title="Admin" />
            {
                menu.map(m => <BoxMenu config={m} onClick={m.onClick || (() => { })} />)
            }
        </div>
    )
}

export default Admin